import React, {FC} from "react"

import {WellnessMedia} from "@irati/types"

import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import BaseSvgIcon from "@irati/ui/src/Icon/customIcons/Base"
import History from "@irati/utils/history"
import tracking from "@irati-tracking/wellness"
import styled from "styled-components"

interface Props {
  media: WellnessMedia
  color?: string
}

const StyledFlex = styled(Flex)`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const MediaImportantTags: FC<Props> = ({media, color}) => {
  const handleSelectCategory = (uuid: string, name: string) => {
    tracking.viewCategorySelected(name)
    History.push({
      pathname: `/wellness/categories/${uuid}`
    })
  }

  return (
    <Flex marginTop>
      <StyledFlex onClick={() => handleSelectCategory(media.category.uuid, media.category.name)}>
        <BaseSvgIcon viewBox="0 0 30 30" width={14} height={14} fill={color} marginRight>
          <path d={media.category.svgData} />
        </BaseSvgIcon>
        <Label color={color}>{media.category.mediaLabel}</Label>
      </StyledFlex>
    </Flex>
  )
}

export default MediaImportantTags
